var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import View from './View';
import { Button } from './index';
import cloneDeep from 'lodash/cloneDeep';
var ToggleSelect = /** @class */ (function (_super) {
    __extends(ToggleSelect, _super);
    function ToggleSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            tooltip: false,
            options: _this.props.options || []
        };
        _this.handleToggleTooltip = function () {
            _this.setState(function (prev) { return ({ tooltip: !prev.tooltip }); });
        };
        _this.getSelected = function () {
            var options = _this.props.options || [];
            var selected = [];
            for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
                var option = options_1[_i];
                if (option.selected) {
                    selected.push(option);
                }
            }
            return selected;
        };
        _this.handleClick = function (item) {
            // console.log('handleClick - item: ', item)
            if (_this.props.maxSelectable && _this.props.multiple && !item.selected) {
                if (_this.getSelected().length === _this.props.maxSelectable) {
                    return _this.props.onMaxSelected && _this.props.onMaxSelected();
                }
            }
            var updatedOptions = cloneDeep(_this.state.options).map(function (option) { return (__assign({}, option)); });
            var indexClicked = updatedOptions.findIndex(function (option) { return option.value === item.value; });
            if (indexClicked === -1) {
                console.warn('Item not found in options:', item);
                return;
            }
            if (!_this.props.multiple) {
                updatedOptions.forEach(function (value, indx) {
                    updatedOptions[indx].selected = false;
                });
            }
            updatedOptions[indexClicked].selected = !item.selected;
            var event = { target: { options: updatedOptions } };
            _this.setState({ options: updatedOptions });
            _this.props.onChange(event);
        };
        return _this;
    }
    ToggleSelect.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.options !== this.props.options) {
            this.setState({ options: this.props.options || [] });
        }
    };
    ToggleSelect.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, name = _a.name, onError = _a.onError, styleItem = _a.styleItem;
        var options = this.state.options;
        return (React.createElement(View, { id: id, name: name, flex: true, row: true, allowWrap: true, center: true }, options && options.map(function (item) {
            var selected = item.selected;
            var disabled = item.disabled;
            if (selected && disabled && onError) {
                onError(item);
            }
            if (_this.props.itemChild) {
                return _this.props.itemChild(item, _this.handleClick);
            }
            return (React.createElement(ToggleSelectItem, { style: styleItem, key: 'tgi' + String(item.id || item.value), extractKey: "".concat(item.name, "_").concat(String(item.id || item.value)), selected: !!selected, disabled: !!disabled, onClick: function () {
                    _this.handleClick(item);
                } }, item.name));
        })));
    };
    ToggleSelect.defaultProps = {
        multiple: false
    };
    return ToggleSelect;
}(Component));
export default ToggleSelect;
export var ToggleSelectItem = function (_a) {
    var selected = _a.selected, disabled = _a.disabled, style = _a.style, children = _a.children, extractKey = _a.extractKey, onClick = _a.onClick;
    return (React.createElement(Button, { key: extractKey, style: __assign({ borderRadius: 5, borderWidth: 1, borderStyle: 'solid', borderColor: "".concat(selected || disabled ? 'white' : 'black'), padding: 6, 
            /*marginTop: 5,
            marginBottom: 5,
            marginLeft: 10,
            marginRight: 10,*/
            margin: 2, backgroundColor: disabled ? 'red' : selected ? 'green' : undefined, color: disabled || selected ? 'white' : undefined }, style), onClick: function () { return !disabled ? onClick() : undefined; } }, children));
};



//////////////////
// WEBPACK FOOTER
// ./src/elements/ToggleSelect.tsx
// module id = 98
// module chunks = 0